import {
  DRUGAFTERCAREPROGRAMS_TABLE,
  GET_DRUGAFTERCAREPROGRAMS_LIST_PENDING,
  GET_DRUGAFTERCAREPROGRAMS_LIST_FULFILLED,
  GET_DRUGAFTERCAREPROGRAMS_LIST_REJECTED,
  GET_DRUGAFTERCAREPROGRAM_PENDING,
  GET_DRUGAFTERCAREPROGRAM_FULFILLED,
  GET_DRUGAFTERCAREPROGRAM_REJECTED,
  DELETE_DRUGAFTERCAREPROGRAM_FULFILLED,
  DELETE_DRUGAFTERCAREPROGRAM_PENDING,
  ADD_DRUGAFTERCAREPROGRAM_FULFILLED,
  UPDATE_DRUGAFTERCAREPROGRAM_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Drug Aftercare Programs',
  tablename: DRUGAFTERCAREPROGRAMS_TABLE,
  drugaftercareprograms: [],
  loadingList: false,
  errors: []
}
const reducerDrugAftercarePrograms = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_DRUGAFTERCAREPROGRAM_PENDING:
    case GET_DRUGAFTERCAREPROGRAMS_LIST_PENDING:
    case DELETE_DRUGAFTERCAREPROGRAM_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_DRUGAFTERCAREPROGRAMS_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        drugaftercareprograms: dataUndefinedTestReturn
      }
      break
    case GET_DRUGAFTERCAREPROGRAM_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        drugaftercareprograms: dataUndefinedTestReturn
      }
      break
    case DELETE_DRUGAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_DRUGAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_DRUGAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_DRUGAFTERCAREPROGRAMS_LIST_REJECTED:
    case GET_DRUGAFTERCAREPROGRAM_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    default:
      return state
  }
  return state
}
export default reducerDrugAftercarePrograms
